// Copyright (c) 2023. Engie-Electrabel. All rights reserved.
//
// Engie-Electrabel n.v./s.a., Simon Bolivarlaan 34 Boulevard Simón Bolivar, BTW BE 0403.107.701 - 1000 Brussel/Bruxelles, Belgium.
//
// Proprietary Notice:
// This software is the confidential and proprietary information of Engie-Electrabel s.a./n.v. and/or its licensors.
// You shall not disclose this Confidential Information to any third parties and any use thereof shall be subject to the terms and conditions of use, as agreed upon with Engie-Electrabel in writing.
//

import type { DirectiveBinding, VNode, App } from '@vue/runtime-core'
import { hasOneOfRoles } from '@service-portal/commons'

export default function install (app: App): void {
  async function hasRole (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const userRoles = await window.auth.getUserRoles()
    if (!hasOneOfRoles(userRoles, binding.value ? [binding.value] : [])) {
      const behaviour = binding.modifiers.disable ? 'disable' : 'hide'
      if (behaviour === 'hide') {
        if (vnode.el && vnode.el.parentElement) {
          vnode.el.parentElement.removeChild(vnode.el)
        }
      } else if (behaviour === 'disable') {
        el.setAttribute('disabled', 'true')
        el.classList.add('is-disabled')
      }
    }
  }

  app.directive('has-role', {
    beforeMount: hasRole,
    unmounted: hasRole
  })
}
